<template>
<!-- Footer do Carrinho e Checkout para as telas de Carrinho e Checkout -->
<footer class="group__footer">
    <div class="group__footer__content">
        <div class="container-one">
            <div class="logo">
                <a v-bind:href="'/'">
                    <img :src="logoUrl" alt="Marca Onboard Entretenimento">
                </a>
            </div>
            <div class="payment-methods">
                <div class="title">Formas de Pagamento</div>
                <div class="payment-methods__list">
                    <div class="payment-method">
                        <img :src="logoFormaPagamentoPix" alt="Boleto">
                    </div>
                    <div class="payment-method">
                        <img :src="logoFormaPagamentoBoleto" alt="Pix">
                    </div>
                    <div class="payment-method">
                        <img :src="logoFormaPagamentoMastercard" alt="Mastercard">
                    </div>
                    <div class="payment-method">
                        <img :src="logoFormaPagamentoVisa" alt="Visa">
                    </div>
                    <div class="payment-method">
                        <img :src="logoFormaPagamentoAmericanExpress" alt="American Express">
                    </div>
                    <div class="payment-method">
                        <img :src="logoFormaPagamentoDiners" alt="Diners">
                    </div>
                    <div class="payment-method">
                        <img :src="logoFormaPagamentoElo" alt="Elo">
                    </div>
                    <div class="payment-method">
                        <img :src="logoFormaPagamentoHipercard" alt="Hipercard">
                    </div>
                </div>
            </div>
            <div class="security-qualities">
                <div class="title">Segurança e Qualidade</div>
                <div class="security-quality__list">
                    <div class="security-quality">
                        <img :src="logoSegurancaLetsEncrypt" alt="Lets Encrypt">
                    </div>
                    <div class="security-quality">
                        <img :src="logoSegurancaMercadoPago" alt="Mercado Pago">
                    </div>
                </div>
            </div>
            <div class="contact">
                <div class="title">Contato</div>
                <ul class="contact__list">
                    <li><i class="fa-solid fa-phone"></i> (11) 99999-9999</li>
                    <li><i class="fa-solid fa-envelope"></i> atendimento@onboard.com.br</li>
                </ul>
            </div>
        </div>
        <div class="container-two">
            <p>
                <b>Onboard Entretenimento | CNPJ: 42.112.589/0001-60</b> | Rua Luigi Galvani, 70, Conjunto 81/82, Cidade Moncoes, São Paulo, SP. CEP: 04575-020 |
                <b>Horário de Atendimento:</b> 8h a 18h, Segunda a Sexta Feira, exceto feriados
            </p>
        </div>
    </div>
</footer>
</template>

<script setup>
    import logoUrl from '@/assets/logo.png'
    import logoFormaPagamentoPix from '@/assets/logo-forma-pagamento-pix.png'
    import logoFormaPagamentoBoleto from '@/assets/logo-forma-pagamento-boleto.png'
    import logoFormaPagamentoMastercard from '@/assets/logo-forma-pagamento-mastercard.png'
    import logoFormaPagamentoVisa from '@/assets/logo-forma-pagamento-visa.png'
    import logoFormaPagamentoAmericanExpress from '@/assets/logo-forma-pagamento-american-express.png'
    import logoFormaPagamentoDiners from '@/assets/logo-forma-pagamento-diners.png'
    import logoFormaPagamentoElo from '@/assets/logo-forma-pagamento-elo.png'
    import logoFormaPagamentoHipercard from '@/assets/logo-forma-pagamento-hipercard.png'
    import logoSegurancaLetsEncrypt from '@/assets/logo-seguranca-lets-encrypt.png'
    import logoSegurancaMercadoPago from '@/assets/logo-seguranca-mercado-pago.png'
</script>